<template>
  <!--begin::Leave Listing-->
  <div class="leave-template">
    <PageHeaderCount
      moduleType="leave"
      :dataLoading="dataLoading"
      :statusList="getLeaveStatus"
      allkey="all_leave"
      countkey="leave_status_count"
    ></PageHeaderCount>
    <ListingTemplate :customClass="'leave-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="false">
              <v-col cols="4" class="pt-0">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  Selected
                </h1>
              </v-col>
              <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
                <template>
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ attrs }">
                      <v-btn
                        depressed
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on:click="deleteLeave"
                      >
                        Bulk Delete
                      </v-btn>
                    </template>
                    <v-list>
                      <!--<template v-for="(item, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="bulkAction(item.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              item.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>-->
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-col>
            </template>
            <template>
              <v-col cols="4" class="py-0">
                <h1 class="form-title margin-auto">
                  <v-select
                    style="max-width: 150px !important"
                    :disabled="dataLoading"
                    :items="getLeaveStatus"
                    v-model="status_filter"
                    @change="leaveFilter"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                        <!-- <v-list-item-subtitle
                          v-text="item.description"
                        ></v-list-item-subtitle> -->
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_leave
                          }}</template>
                          <template v-else>{{
                            item.leave_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-col>
              <v-col cols="4" class="py-0 float-end d-flex justify-flex-end">
                <v-text-field
                  v-model.trim="filter_search"
                  v-on:click:clear="clearFilter('search')"
                  clearable
                  dense
                  filled
                  flat
                  label="Type and press enter to search"
                  hide-details
                  style="max-width: 300px"
                  solo
                  :loading="pageLoading"
                  :disabled="pageLoading"
                  color="cyan"
                  append-icon="mdi-magnify"
                  @keydown.enter="leaveFilter"
                  @keydown.tab="leaveFilter"
                  v-on:change="leaveFilter"
                ></v-text-field>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  color="#24326d"
                  class="mx-1 custom-bold-button white--text"
                  @click="create_leave_dialog = true"
                >
                  <v-icon dark left>mdi-plus</v-icon> Create
                </v-btn>

                <v-btn
                  depressed
                  :disabled="dataLoading"
                  v-if="false"
                  color="cyan"
                  class="mx-2 custom-bold-button white--text"
                  @click="leaveListingEvent = !leaveListingEvent"
                >
                  <v-icon size="20" dark>{{
                    leaveListingEvent ? "mdi-view-list" : "mdi-grid"
                  }}</v-icon>
                </v-btn>

                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>

                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    v-on:change="updateVisible()"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          v-on:change="updateVisible()"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
              </v-col>

              <v-menu
                v-if="false"
                v-model="datePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense
                    filled
                    flat
                    label="Date Range"
                    hide-details
                    class="ml-2"
                    solo
                    :disabled="pageLoading"
                    clearable
                    prepend-inner-icon="mdi-calendar"
                    v-on:click:clear="clearFilter('dates')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="formattedDate"
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-if="false"
                  color="cyan"
                  range
                  :disabled="pageLoading"
                  v-on:change="leaveFilter"
                  v-model="dates"
                ></v-date-picker>
              </v-menu>
              <v-autocomplete
                v-if="false"
                :items="userList"
                v-model="filter_user"
                dense
                flat
                clearable
                filled
                label="Staff"
                item-color="cyan"
                v-on:click:clear="clearFilter('user')"
                color="cyan"
                solo
                :disabled="pageLoading"
                v-on:change="leaveFilter"
                item-value="id"
                item-text="display_name"
                class="filter-select ml-2"
              />
              <v-autocomplete
                v-if="false"
                :items="leaveCategory"
                v-model="filter_category"
                dense
                flat
                filled
                clearable
                label="Category"
                v-on:click:clear="clearFilter('category')"
                item-color="cyan"
                color="cyan"
                solo
                :disabled="pageLoading"
                v-on:change="leaveFilter"
                item-value="name"
                item-text="name"
                class="filter-select ml-2"
              />

              <PageTips v-if="false" module="leave"></PageTips>
            </template>
          </template>
        </ListingHeader>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <template v-if="leaveListingEvent">
            <LeaveKanban
              @open-dialog="openLeaveDetail($event)"
              @status-dialog="
                (statusDialog = $event),
                  ((visits = []),
                  (rejected_remark = null),
                  (cancelled_remark = null))
              "
              @assign:visit="visits = $event"
              @status-data="statusdata = $event"
              @leave-details="leaveDetails"
              @status-change="dropData()"
              :status-data="statusdata"
            ></LeaveKanban>
          </template>
          <template v-else>
            <LeaveListing
              @status-dialog="
                (statusDialog = $event),
                  ((visits = []),
                  (rejected_remark = null),
                  (cancelled_remark = null))
              "
              @status-data="statusdata = $event"
              @leave-details="leaveDetails"
              :autoRefresh="autoRefresh"
            ></LeaveListing>
          </template>
        </perfect-scrollbar>
      </template>
    </ListingTemplate>

    <template v-if="create_leave_dialog">
      <CreateLeave
        :drawer="create_leave_dialog"
        :leaveUpdateData="leaveCreate"
        @close="
          leaveCreate = {};
          create_leave_dialog = false;
        "
      ></CreateLeave>
    </template>
    <Dialog
      v-if="statusDialog"
      :common-dialog="statusDialog"
      :dialog-width="640"
      isClass
    >
      <template v-slot:title>
        <div class="d-flex">Confirmed</div>
      </template>
      <template v-slot:body>
        <v-form v-model="formValid">
          <v-row class="delete-dialog">
            <v-col md="12" class="py-0 my-auto py-2">
              <div class="btx-div m-0" v-if="statusdata == 'approved'">
                <span class="font-weight-600">
                  <template v-if="visits && visits.visitBarcode">
                    <div style="font-size: 19px !important">
                      Assigned Visits :-
                      <span class="font-weight-500 red--text mr-2">{{
                        visits.visitBarcode
                      }}</span>
                    </div>
                    <br />
                  </template>
                  <span style="font-size: 18px !important">
                    Are you sure, You want to Approve this Leave
                  </span>

                  <v-chip outlined label color="green" class="ml-2"
                    ><span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp;?
                </span>
              </div>
              <div class="btx-div m-0" v-if="statusdata == 'cancelled'">
                <span class="font-weight-600">
                  <template v-if="visits && visits.visitBarcode">
                    <div style="font-size: 19px !important">
                      Assigned Visits :-
                      <span class="font-weight-500 red--text mr-2">{{
                        visits.visitBarcode
                      }}</span>
                    </div>
                    <br />
                  </template>
                  <span style="font-size: 18px !important">
                    Are you sure, You want to Cancel this Leave</span
                  >

                  <v-chip outlined label color="teal" class="ml-2"
                    ><span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp;?
                </span>
                <div class="mt-3" v-if="statusdata == 'cancelled'">
                  <label class="input-label required mb-1">Cancel Reason</label>
                  <v-textarea
                    auto-grow
                    dense
                    :rules="[
                      validateRules.required(cancelled_remark, 'Reason'),
                    ]"
                    filled
                    color="cyan"
                    v-model="cancelled_remark"
                    placeholder="Reason for cancellation"
                    solo
                    flat
                    row-height="15"
                    v-on:keypress="(e) => manageLimit(e)"
                    v-on:paste="(e) => onPaste(e)"
                  ></v-textarea>
                  <v-col md="12" class="text-right"
                    >{{
                      cancelled_remark ? cancelled_remark.length : 0
                    }}/200</v-col
                  >
                </div>
              </div>
              <div v-if="statusdata == 'rejected'">
                <span class="font-weight-600">
                  <span style="font-size: 19px !important">
                    Are you sure, You want to Reject this Leave
                  </span>

                  <!--  {{ leaveId.length > 1 ? "these leaves" : "this Leave" }} -->
                  <v-chip outlined label color="red" class="ml-2">
                    <span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp; ?
                </span>

                <div class="mt-3" v-if="statusdata == 'rejected'">
                  <label class="input-label required mb-1">Reject Reason</label>
                  <v-textarea
                    auto-grow
                    dense
                    :rules="[validateRules.required(rejected_remark, 'Reason')]"
                    filled
                    color="cyan"
                    v-model="rejected_remark"
                    placeholder="Reason for leave"
                    solo
                    flat
                    row-height="15"
                    v-on:keypress="(e) => limitRejectedRemark(e)"
                    v-on:paste="(e) => onPasteRejectedRemark(e)"
                  ></v-textarea>
                  <v-col md="12" class="text-right"
                    >{{
                      rejected_remark ? rejected_remark.length : 0
                    }}/200</v-col
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          :disabled="!formValid"
          @click="dropData(visits.visitId)"
          style="min-width: 78px !important"
        >
          <template
            v-if="
              visits &&
              visits.visitId &&
              visits.visitId.length > 0 &&
              statusdata == 'approved'
            "
          >
            Approve & UnAssigned
          </template>
          <template v-else>
            <template v-if="statusdata == 'approved'"> Approve </template>
            <template v-if="statusdata == 'cancelled'"> Cancel </template>
            <template v-if="statusdata == 'rejected'"> Reject </template>
          </template>
        </v-btn>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          @click="statusDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>

    <Dialog :commonDialog="searchDialog">
      <template v-slot:title>Filter Leaves</template>
      <template v-slot:body>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="position: relative"
        >
          <v-container fluid class="pt-0 custom-search-filter">
            <v-row>
              <v-col md="6" v-if="false">
                <v-text-field
                  v-model.trim="filter_search"
                  v-on:click:clear="clearFilter('search')"
                  clearable
                  dense
                  filled
                  flat
                  label="Search"
                  hide-details
                  solo
                  :loading="pageLoading"
                  :disabled="pageLoading"
                  color="cyan"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  v-model.trim="barcode"
                  v-on:click:clear="clearFilter('barcode')"
                  clearable
                  dense
                  filled
                  flat
                  label="Leave #"
                  hide-details
                  solo
                  :loading="pageLoading"
                  :disabled="pageLoading"
                  color="cyan"
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-menu
                  v-model="datePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      filled
                      flat
                      label="Date Range"
                      hide-details
                      class="ml-2"
                      solo
                      :disabled="pageLoading"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      v-on:click:clear="clearFilter('dates')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :value="formattedDate"
                      color="cyan"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    color="cyan"
                    range
                    :disabled="pageLoading"
                    v-model="dates"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-autocomplete
                  :items="userList"
                  v-model="filter_user"
                  dense
                  flat
                  clearable
                  filled
                  label="Staff"
                  item-color="cyan"
                  v-on:click:clear="clearFilter('user')"
                  color="cyan"
                  solo
                  :disabled="pageLoading"
                  item-value="id"
                  item-text="display_name"
                  class="filter-select"
                />
              </v-col>
              <v-col md="6">
                <v-autocomplete
                  :items="leaveCategory"
                  v-model="filter_category"
                  dense
                  flat
                  filled
                  clearable
                  label="Category"
                  v-on:click:clear="clearFilter('category')"
                  item-color="cyan"
                  color="cyan"
                  solo
                  :disabled="pageLoading"
                  item-value="name"
                  item-text="name"
                  class="filter-select ml-2"
                />
              </v-col>
            </v-row>
          </v-container>
        </perfect-scrollbar>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="dataLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text"
          v-on:click="
            () => {
              leaveFilter();
              searchDialog = false;
              isFilterDrawer = false;
            }
          "
        >
          Filter
        </v-btn>
        <v-btn
          depressed
          :disabled="dataLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="searchDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
    <VCard
      border
      class="pr-3 py-0 filter-enabled main-listing-page"
      v-if="isFilterApply() && !isFilterDrawer"
    >
      <div class="d-flex">
        <div class="d-flex">
          <div
            class="mr-1 px-2 font-weight-medium text-uppercase text-center"
            style="
              font-size: 15px;
              border-right: 1px solid #f7e3cd;
              background-color: #f7e3cd;
            "
          >
            Filtered<br />
            By
          </div>
          <div>
            <template v-if="filter_search">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('search')"
                >{{ filter_search }}
              </VChip>
            </template>
            <template v-if="dates && dates.length">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('dates')"
                >Dates Between: {{ formattedDates }}
              </VChip>
            </template>
            <template v-if="filter_user">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('user')"
                >Staff : {{ g_filter_user() }}
              </VChip>
            </template>
            <template v-if="barcode">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('barcode')"
                >Leave # : {{ barcode }}
              </VChip>
            </template>
            <template v-if="filter_category">
              <VChip
                label
                class="ma-1"
                close
                @click:close="() => removeFilters('category')"
                >Category : {{ g_filter_category() }}</VChip
              >
            </template>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              size="small"
              v-bind="attrs"
              v-on="on"
              @click="removeFilters('all')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Remove All Filters</span>
        </v-tooltip>
      </div>
    </VCard>
  </div>
  <!--end::Leave Listing-->
</template>

<style>
.filter-enabled {
  background-color: #fdf0d1 !important;
  position: fixed;
  bottom: 10px;
  left: 50%;
  max-width: 768px;
  min-width: 480px;
  transform: translateX(-50%);
  z-index: 9;
}
</style>

<script>
import draggable from "vuedraggable";

import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH, GET, DELETE, POST } from "@/core/services/store/request.module";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import { mapGetters } from "vuex";
import {
  GET_LEAVE_STATUS,
  SET_LOADING,
  SET_FILTER,
  RESET_STATE,
} from "@/core/services/store/leave.module";
import { SearchEventBus } from "@/core/lib/search.lib";

//import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
//import Dialog from "@/view/pages/partials/Dialog.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import Dialog from "@/view/pages/partials/Dialog";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
//import DateRangePicker from "@/view/pages/partials/DateRangePicker";
import CreateLeave from "@/view/pages/leave/Create-Or-Update/CreateLeave";
import LeaveKanban from "@/view/pages/leave/LeaveKanban";
import LeaveListing from "@/view/pages/leave/LeaveListing";
export default {
  mixins: [CommonMixin, ValidationMixin, ListingMixin],
  name: "leave-list",
  data() {
    return {
      isFilterDrawer: false,
      create_leave_dialog: false,
      leaveBarcode: null,
      leaveId: null,
      exportLoading: false,
      statusdata: null,
      dataLoading: false,
      leaveListingEvent: false,
      leaveCreate: null,
      pageModule: "leave-listing",
      routeAPI: "leave",
      routeName: "leave",
      routeDetailName: "leave.detail",
      status: "all",
      queryParams: {},
      searchDialog: false,
      box: false,
      leaveCategory: [],
      userList: [],
      dates: [],
      filter_category: null,
      barcode: null,
      status_filter: "all",
      filter_user: 0,
      filter_search: null,
      visits: [],
      autoRefresh: false,
      pageLoading: false,
      selectedRows: [],
      formValid: true,
      statusList: [],
      rejected_remark: null,
      cancelled_remark: null,
      statusDialog: false,
      moreActions: [
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      rows_selected: [],
      searchableArray: [
        "barcode",
        "display_name",
        "category",
        "reason",
        "status",
      ],
    };
  },
  // watch: {},
  watch: {
    "$route.query.status"(status) {
      this.status_filter = status || "all";
      this.leaveFilter();
    },
  },
  components: {
    draggable,
    PageHeaderCount,
    PageTips,
    ListingTemplate,
    ListingHeader,
    Dialog,
    CreateLeave,
    LeaveKanban,
    LeaveListing,
  },
  methods: {
    update_selected(param) {
      this.rows_selected = param;
    },

    manageLimit(e) {
      if (this.cancelled_remark && this.cancelled_remark.length > 199) {
        e.preventDefault();
      }
    },

    limitRejectedRemark(e) {
      if (this.rejected_remark && this.rejected_remark.length > 199) {
        e.preventDefault();
      }
    },

    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.cancelled_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.cancelled_remark = trimValue;
        e.preventDefault();
      }
    },

    onPasteRejectedRemark(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.rejected_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.rejected_remark = trimValue;
        e.preventDefault();
      }
    },

    updateVisible() {
      const _this = this;
      for (let index = 0; index < _this.defaultColDefs.length; index++) {
        const element = _this.defaultColDefs[index];
        _this.defaultColDefs[index].visible = 0;
        if (_this.defaultColShow.includes(element.field)) {
          _this.defaultColDefs[index].visible = 1;
        }
      }

      _this.$nextTick(() => {
        _this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then(({ data }) => {
            this.customThead = data;
            LeaveApplyEventBus.$emit("refresh-headers", data);
          });
      });
    },
    leaveDetails(event) {
      this.leaveBarcode = event.barcode;
      this.leaveId = [event.leaveId];
    },
    clearFilter(type) {
      if (type == "dates") {
        this.dates = [];
      } else if (type == "category") {
        this.filter_category = null;
      } else if (type == "barcode") {
        this.barcode = null;
      } else if (type == "user") {
        this.filter_user = null;
      } else if (type == "search") {
        this.filter_search = null;
      }
      this.leaveFilter();
    },
    /*  updateLeave(param) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/" + param,
        })
        .then(({ data }) => {
          _this.create_leave_dialog = true;
          _this.leaveCreate = new Object({
            id: data && data.id ? data.id : 0,
            staff: data && data.staff ? data.staff : null,
            user_data: data && data.user_data ? data.user_data : null,
            category: data && data.category ? data.category : null,
            duration: data && data.duration ? data.duration : 0,
            duration_type: data && data.duration_type ? data.duration_type : 0,
            day_type: data && data.day_type ? data.day_type : 1,
            start_date: data && data.start_date ? data.start_date : null,
            end_date: data && data.end_date ? data.end_date : null,
            reason: data && data.reason ? data.reason : null,
            role: data && data.role ? data.role : null,
          });
        })
        .catch((error) => {
          _this.logError(error);
          _this.goBack();
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    }, */
    clearSelections() {
      this.selectedRows = [];
    },
    bulkAction(action) {
      const _this = this;
      switch (action) {
        case "approved":
          _this.updateLeaveStatus(2);
          break;
        case "cancelled":
          _this.updateLeaveStatus(4);
          break;
        case "rejected":
          _this.updateLeaveStatus(3);
          break;
      }
    },
    updateLeaveStatus(status) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "leave/status",
          data: { leave: _this.selectedRows, status },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    dropData(visit) {
      this.autoRefresh = false;
      this.pageLoading = true;
      let payload = {
        visit: visit,
        leaves: this.leaveId,
        status: this.statusdata, // 1: Pending, 2: Approved, 3: Rejected 4: cancelled
        remark:
          this.statusdata == "rejected"
            ? this.rejected_remark
            : this.statusdata == "cancelled"
            ? this.cancelled_remark
            : null,
      };
      this.$store
        .dispatch(PATCH, {
          url: `leave/${this.leaveId}/${this.statusdata}`,
          data: payload,
        })
        .then(() => {
          this.statusDialog = false;
          this.detailDialog = false;
          this.reject_remark = null;
          this.cancelled_remark = null;

          this.autoRefresh = true;
          LeaveApplyEventBus.$emit("refresh");
          this.getAllLeaveStatus();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    leaveFilter() {
      let _this = this;
      let leaveFilter = {
        daterange: _this.dates,
        search: _this.lodash.toString(_this.filter_search) || null,
        user: _this.lodash.toSafeInteger(_this.filter_user) || null,
        category: _this.lodash.toString(_this.filter_category) || null,
        barcode: _this.lodash.toString(_this.barcode) || null,
        status: _this.lodash.toString(_this.status_filter) || null,
      };
      _this.$store.dispatch(SET_FILTER, leaveFilter);
    },
    getLeaveDays() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/options",
        })
        .then(({ data }) => {
          _this.userList = data.users;
          _this.leaveCategory = data.leave_type;
          _this.leaveCategory.push({
            name: "UnPaid",
          });
          this.leaveCategory = this.lodash.map(this.leaveCategory, (row) => {
            return { ...row, category: row.category.replace("-", " ") };
          });
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          break;
        case "export_items":
          _this.LeaveExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("leave");
          break;
        case "refresh_list":
          window.location.reload();
          break;
      }
    },
    deleteLeave() {
      const _this = this;
      _this.$store
        .dispatch(DELETE, {
          url: "leave/" + _this.leaveId,
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getAllLeaveStatus() {
      const _this = this;
      _this.$store.dispatch(SET_LOADING, true);
      _this.$store
        .dispatch(GET_LEAVE_STATUS, {})
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          _this.$store.dispatch(SET_LOADING, false);
        });
    },
    filterRows() {
      this.leaveFilter();
      this.searchDialog = false;
    },
    getFilterLabel(field, module) {
      console.log(module);

      const labels = {
        barcode: "Leave #",
        display_name: "User Name",
        category: "Category",
        reason: "Reason",
        status: "Status",
      };
      return labels[field] || field;
    },
    isFilterApply() {
      let isFilter = false;
      if (
        this.filter_search ||
        this.filter_user ||
        this.filter_category ||
        this.barcode ||
        this.dates?.length
      ) {
        isFilter = true;
      }
      return isFilter;
    },
    g_filter_user() {
      const user = this.userList?.find((row) => row.id === this.filter_user);
      return user?.display_name;
    },
    g_filter_category() {
      const category = this.leaveCategory?.find(
        (row) => row.name === this.filter_category
      );
      console.log("category", category);

      return category?.name || this.filter_category;
    },

    // formattedDate() {
    //   if (!this.dates || !this.dates.length) return '';
    //   return this.dates.join(' ~ ');
    // },
    removeFilters(type) {
      if (type === "all") {
        this.filter_search = null;
        this.filter_user = null;
        this.filter_category = null;
        this.barcode = null;
        this.dates = [];
      } else if (type === "search") {
        this.filter_search = null;
      } else if (type === "user") {
        this.filter_user = null;
      } else if (type === "category") {
        this.filter_category = null;
      } else if (type === "barcode") {
        this.barcode = null;
      } else if (type === "dates") {
        this.dates = [];
      }
      this.leaveFilter();
    },
  },

  computed: {
    ...mapGetters(["getLeaveStatus"]),

    formattedDates() {
      if (!this.dates || !this.dates.length) return "";

      return this.dates
        .map((date) => {
          const d = new Date(date);
          const day = String(d.getDate()).padStart(2, "0");
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const year = d.getFullYear();
          return `${day}-${month}-${year}`;
        })
        .join(" ~ ");
    },
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);
    _this.status = _this.$route.query.status || _this.status;
    _this.status_filter = _this.status;
    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 10;

    _this.leaveFilter();
  },
  mounted() {
    SearchEventBus.$emit("search-template", false);
    this.getAllLeaveStatus();
    this.getLeaveDays();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Leave",
      },
    ]);
    LeaveApplyEventBus.$on("refresh", () => {
      this.autoRefresh = true;
      setTimeout(() => {
        this.autoRefresh = false;
      }, 1000);
    });
  },
  beforeDestroy() {
    SearchEventBus.$emit("search-template", false);
    this.$store.dispatch(RESET_STATE);
    LeaveApplyEventBus.$off("refresh");
  },
};
</script>
